import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Loader, Button, Icon, List } from 'semantic-ui-react';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { base64toBlob } from '../../../utils/fileSaverHelper';
import ItemHistorico from './ItemHistorico';
import CampoData from '../../layouts/CampoData';
import api from '../../../api';

const Historico = ({ match: { params } }) => {
  const [loading, setLoading] = useState(true);
  const [condominio, setCondominio] = useState({});
  const [pagamentos, setPagamentos] = useState([]);
  const [errors, setErrors] = useState({});
  const [periodo, setPeriodo] = useState({ inicio: '', fim: '' });
  const [gerandoExtrato, setGerandoExtrato] = useState(false);
  const [erroExtrato, setErroExtrato] = useState('');
  const [filtro, setFiltro] = useState('todos');
  const [extratoAberto, setExtratoAberto] = useState(false);

  useEffect(
    () => {
      const init = async () => {
        try {
          const condominioRes = await api.condominio.findSimpleById(params.id);
          const pagamentosRes = await api.pagamento.find(condominioRes._id);

          setCondominio(condominioRes);
          setPagamentos(pagamentosRes.pagamentos);
          setLoading(false);
        } catch (e) {
          setErrors((e.data && e.data.errors) || {});
        }
      };
      init();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

    const consultarStatus = async (hash) => {
        try {
            setLoading(true);
            const response = await api.pagamento.updateStatus(hash);
            setPagamentos(pagamentos.map(it => {
                let result = it;
                if (it.hash === response.hash) {
                    result = response;
                }
                return result;
            }));
            const condominioRes = await api.condominio.findSimpleById(params.id);
            setCondominio(condominioRes);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

  const gerarExtrato = async () => {
    setGerandoExtrato(true);
    setErroExtrato('');
    try {
      const fmt = valor => (valor && moment(valor, 'DD/MM/YYYY', true).isValid() ? valor : undefined);
      const response = await api.pagamento.relatorioExtrato(condominio._id, {
        dataInicial: fmt(periodo.inicio),
        dataFinal: fmt(periodo.fim),
      });
      saveAs(await base64toBlob(response.data, 'application/pdf'), 'extrato-pagamentos.pdf');
    } catch (e) {
      setErroExtrato('Não foi possível gerar o extrato. Verifique o período informado.');
    }
    setGerandoExtrato(false);
  };

  const FILTROS = [
    ['todos', 'Todos', () => true],
    ['confirmados', 'Confirmados', p => p.status === 'CO'],
    ['pendentes', 'Pendentes', p => p.status === 'PE' || p.status === 'OP'],
    ['cancelados', 'Cancelados', p => p.status === 'CA'],
  ];
  const filtroAtual = FILTROS.find(f => f[0] === filtro);
  const visiveis = pagamentos.filter(filtroAtual[2]);

  const getPagamentos = () =>
    visiveis.length ? (
      <List verticalAlign="middle">
        {visiveis.map(pagamento => (
          <ItemHistorico key={pagamento.hash || pagamento._id} pagamento={pagamento} consultarStatus={() => consultarStatus(pagamento.hash)} />
        ))}
      </List>
    ) : (
      <div className="empty-illustration-1">
        <img src="/images/illustrations/lupa-casa.svg" alt="Nenhum pagamento encontrado" />
      </div>
    );

  return (
    <div>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <header className="va-un-cabecalho">
          <div>
            <h1>Histórico de pagamentos</h1>
            <p>Acompanhe as cobranças, o valor de cada compra e a situação do plano.</p>
          </div>
        </header>

        {!loading && (
          <div className="va-un-filtros">
            <div className="va-un-busca">
              <Icon name="file alternate outline" />
              <span>{pagamentos.length} pagamento{pagamentos.length !== 1 && 's'} registrado{pagamentos.length !== 1 && 's'}</span>
            </div>
            <div className="va-un-abas" role="tablist">
              {FILTROS.map(([chave, rotulo, fn]) => {
                const qtd = pagamentos.filter(fn).length;
                return (
                  <button
                    type="button"
                    role="tab"
                    aria-selected={filtro === chave}
                    key={chave}
                    className={`${filtro === chave ? 'ativo' : ''} ${chave === 'pendentes' && qtd > 0 ? 'alerta' : ''}`}
                    onClick={() => setFiltro(chave)}
                  >
                    {rotulo} <span>{qtd}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}

        <section className="va-un-relatorios">
          <button type="button" className="va-un-relatorios-titulo" onClick={() => setExtratoAberto(v => !v)} aria-expanded={extratoAberto}>
            <span><Icon name="file pdf outline" /> Extrato em PDF</span>
            <span className="va-un-relatorios-dica">Cobranças, valores pagos e situação do plano</span>
            <Icon name={extratoAberto ? 'chevron up' : 'chevron down'} />
          </button>
          {extratoAberto && (
            <div className="va-extrato" style={{ marginTop: 10 }}>
              <div className="va-extrato-texto">
                <span>Deixe as datas em branco para todo o histórico.</span>
              </div>
              <div className="va-extrato-campos">
                <label>De <CampoData id="extratoInicio" name="inicio" value={periodo.inicio} onChange={e => setPeriodo(p => ({ ...p, inicio: e.target.value }))} /></label>
                <label>Até <CampoData id="extratoFim" name="fim" value={periodo.fim} onChange={e => setPeriodo(p => ({ ...p, fim: e.target.value }))} /></label>
                <Button className="btn-ui-1" loading={gerandoExtrato} disabled={gerandoExtrato || !condominio._id} onClick={gerarExtrato}>
                  <Icon name="download" /> Baixar extrato
                </Button>
              </div>
              {erroExtrato && <div className="va-extrato-erro">{erroExtrato}</div>}
            </div>
          )}
        </section>

        {loading ? <Loader active inline="centered" style={{ marginTop: 50 }} /> : getPagamentos()}
      </div>
    </div>
  );
};

export default Historico;
